export const COMPONENT_NAME = 'ExploreHotels';
